import {ChartsLayout as Layout} from "../../../components/layout/charts_layout/ChartsLayout";
import {usePageview} from "../../tracking/use_pageview";
import {FLTRDashboards} from "../components/FLTRDashboards";

export const FLTR = () => {
    usePageview();
    return (
        <Layout withHeader={false}>
            <FLTRDashboards />
        </Layout>
    );
};
